import './header.styles';

import HeaderMenu from './components/HeaderMenu';
import MobileMenu from './components/MobileMenu';
import { showModal } from '@/scripts/utils/base';


export default function initHeader() {
   const $header = document.querySelector('.header-js');
   const $headerMenu = $header.querySelector('.header-menu-js');
   const $nav = $header.querySelector('.header-nav-js');

   const headerMenu = window.headerMenu = new HeaderMenu($headerMenu, $nav);
   const mobileMenu = new MobileMenu($headerMenu);

   (function initEvents() {
      window.addEventListener('load', () => {
         headerMenu.update();
      });

      document.body.addEventListener('click', (e) => {
         if (!e.target.closest('.open-mobile-menu-js')) return;
         e.preventDefault();
         mobileMenu.show();
      });
   }());
}
